// Pull in any required Libraries.
// import "./lib/modernizr-dev" (Already loaded)

import {stateContentFilter} from './lib/state-filter';
import otherElectionToggle from './lib/other-election-toggle';
import toggleModal from './lib/simple-modal';
import electionCancelGeolocation from './lib/geolocation-cancel';
import electionlineGeolocation from './lib/geolocation-setup';
import geolocationModalSelect from './lib/geolocation-modal-select';
import electionJumpToLetter from './lib/jump-to-letter';

import './lib/filters';
import './lib/filters-podcast';
import './lib/single-podcast';

// Easy console access to jQuery through '$'
window.$ = jQuery;

// Add the 'State Content Filter' to the 'Window' for use by the <input> field.
if (null !== stateContentFilter) {
  window.stateContentFilter = stateContentFilter;
}

// Theme JS.
jQuery(document).ready(function($){
  otherElectionToggle();

  // console.log('I AM LOADING - Main.js');

  toggleModal();
  electionlineGeolocation();
  electionCancelGeolocation();
  electionJumpToLetter();
  geolocationModalSelect();
});
